export const DATE_FORMAT = 'dd/MM/yyyy';
export const DATE_TIME_FORMAT = 'dd/MM/yyyy HH:mm';

// Excel number formats (Excel uses lowercase m for months when combined with d/y)
export const EXCEL_DATE_NUM_FMT = 'dd/mm/yyyy';
export const EXCEL_DATETIME_NUM_FMT = 'dd/mm/yyyy hh:mm';

export default {
  DATE_FORMAT,
  DATE_TIME_FORMAT,
  EXCEL_DATE_NUM_FMT,
  EXCEL_DATETIME_NUM_FMT,
};

export const LOCALE_MAP: Record<string, string> = {
  he: 'he-IL',
  en: 'en-GB',
};

// Import Angular locale modules and expose them for registration in main.ts
import localeHe from '@angular/common/locales/he';
import localeEn from '@angular/common/locales/en';

export const LOCALE_MODULES: Record<string, any> = { en: localeEn, he: localeHe };

// Locales used for Angular's registerLocaleData (module -> locale id)
export const REGISTER_LOCALE_IDS: Record<string, string> = {
  en: 'en-US',
  he: 'he-IL',
};

export function getLocale(lang?: string): string {
  if (!lang) return 'en-GB';
  // If lang already contains region (en-GB), return as-is
  if (lang.includes('-')) return lang;
  return LOCALE_MAP[lang] ?? lang ?? 'en-GB';
}
